import { render, staticRenderFns } from "./ClaimReserve.vue?vue&type=template&id=2d87e6be&"
import script from "./ClaimReserve.vue?vue&type=script&lang=js&"
export * from "./ClaimReserve.vue?vue&type=script&lang=js&"
import style0 from "./ClaimReserve.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimReserve.vue"
export default component.exports